import { baseApi } from "./baseApi";

const EMAIL_TEMPLATE_BASE_URL = "/email-templates";

export const emailTemplateApi = baseApi.injectEndpoints({
  tagTypes: ["EmailTemplate"],

  endpoints: (builder) => ({
    getEmailTemplateList: builder.query({
      query: (params) => ({
        url: `${EMAIL_TEMPLATE_BASE_URL}`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Lead", _id })),
            { type: "EmailTemplate", id: "LIST" },
          ]
          : [{ type: "EmailTemplate", id: "LIST" }],
    }),

    getEmailTemplateDetail: builder.query({
      query: (id) => `${EMAIL_TEMPLATE_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "EmailTemplate", id },
        { type: "EmailTemplate", id: "LIST" },
      ],
    }),

    addEmailTemplate: builder.mutation({
      query: () => ({
        url: `${EMAIL_TEMPLATE_BASE_URL}`,
        method: "POST",
      }),
      invalidatesTags: (result, error) => [
        { type: "EmailTemplate", id: "LIST" },
      ],
    }),

    updateEmailTemplate: builder.mutation({
      query: (payload) => ({
        url: `${EMAIL_TEMPLATE_BASE_URL}/${payload._id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "EmailTemplate", id: _id },
        { type: "EmailTemplate", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetEmailTemplateDetailQuery,

  useLazyGetEmailTemplateListQuery,

  useAddEmailTemplateMutation,

  useUpdateEmailTemplateMutation,
} = emailTemplateApi;
